var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button } from 'antd';
import { CameraOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { CameraCaptureModal } from './CameraCaptureModal';
export var PhotoAttachField = function (_a) {
    var buildFileName = _a.buildFileName, files = _a.files, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, label = _a.label, modalTitle = _a.modalTitle;
    var t = useTranslation().t;
    var _c = useState(false), isCameraVisible = _c[0], setIsCameraVisible = _c[1];
    return (_jsxs("div", __assign({ className: 'flex flex-wrap items-center gap-2' }, { children: [_jsxs(Button, __assign({ icon: _jsx(CameraOutlined, {}, void 0), disabled: disabled, onClick: function () { return setIsCameraVisible(true); } }, { children: [label || t('Add Photo'), files.length > 0 ? " (" + files.length + ")" : ''] }), void 0), files.length > 0 && (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: 'text-xxs text-gray-500' }, { children: files.length === 1
                            ? t('1 photo will be attached')
                            : files.length + " " + t('photos will be attached') }), void 0), _jsxs("button", __assign({ type: 'button', disabled: disabled, onClick: function () { return onChange([]); }, className: 'flex items-center gap-1 text-xxs text-gray-500 underline', title: String(t('Remove photos')) }, { children: [_jsx(CloseCircleOutlined, {}, void 0), t('Clear')] }), void 0)] }, void 0)), _jsx(CameraCaptureModal, { visible: isCameraVisible, title: modalTitle || label || t('Add Photo'), buildFileName: function (shotIndex) { return buildFileName(files.length + shotIndex); }, onCancel: function () { return setIsCameraVisible(false); }, onConfirm: function (captured) {
                    onChange(__spreadArray(__spreadArray([], files, true), captured, true));
                    setIsCameraVisible(false);
                }, confirmText: t('Add') }, void 0)] }), void 0));
};
export default PhotoAttachField;
